// columnsConfig.ts
import { GridColDef } from '@mui/x-data-grid';

export const columnsConfig: GridColDef[] = [
  {
    field: 'createDate',
    headerName: 'Tarih',
    flex: 1,
    // Bu örnekte createDate kolonunu filtrelenebilir olarak belirtiyoruz.
    // Fakat eğer tarih üzerinden text arama çok anlamlı değilse
    // isterseniz 'filterable: false' yapabilirsiniz.
    filterable: true,
  },
  {
    field: 'createUser',
    headerName: 'Kullanıcı',
    flex: 1,
    filterable: true,
  },
  {
    field: 'currentCode',
    headerName: 'Cari Kod',
    flex: 1,
    filterable: true,
  },
  {
    field: 'currentName',
    headerName: 'Cari Adı',
    flex: 1.5,
    filterable: true,
  },
  {
    
    field: 'amount',
    headerName: 'Tutar',
    flex: 1,
    filterable: false, // Örnek: Filtre kapalı
        
    valueFormatter: (params) => {
      const raw = Number(params);
      if (isNaN(raw)) return '';
      return raw.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  },
  {
    field: 'instalment',
    headerName: 'Taksit',
    flex: 1,
    filterable: false,
  },
  {
    field: 'isRecordErp',
    headerName: 'ERP Kaydı',
    flex: 1,
    filterable: false,
  },
  {
    field: 'bankRecord',
    headerName: 'Banka Durumu',
    flex: 1,
    filterable: false,
  },
  {
    field: 'errorMsg',
    headerName: 'Banka Mesajı',
    flex: 2,
    filterable: false,
  },
  
  {
    field: 'status',
    headerName: 'Durum',
    flex: 1,
    filterable: false,
  },
];
